import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TutorialService {
  private readonly TUTORIAL_KEY = 'calendar-tutorial-dismissed';
  private tutorialVisibleSubject = new BehaviorSubject<boolean>(false);
  
  tutorialVisible$ = this.tutorialVisibleSubject.asObservable();

  constructor() {
    // Don't auto-show tutorial anymore
  }

  checkAndShowTutorialIfNeeded(): void {
    const dismissed = localStorage.getItem(this.TUTORIAL_KEY);
    if (!dismissed) {
      // Show tutorial on first visit after a small delay
      setTimeout(() => {
        this.showTutorial();
      }, 1000);
    }
  }

  showTutorial(): void {
    this.tutorialVisibleSubject.next(true);
  }

  hideTutorial(): void {
    this.tutorialVisibleSubject.next(false);
  }

  dismissTutorial(dontShowAgain: boolean = false): void {
    this.hideTutorial();
    if (dontShowAgain) {
      localStorage.setItem(this.TUTORIAL_KEY, 'true');
    }
  }

  resetTutorial(): void {
    localStorage.removeItem(this.TUTORIAL_KEY);
  }

  isTutorialDismissed(): boolean {
    return localStorage.getItem(this.TUTORIAL_KEY) === 'true';
  }
} 